import React from "react";
import { Spin } from "antd";
import PropTypes from "prop-types";

const Spinner = ({ message }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <Spin size="large" />
      {message && <h4>{message}</h4>}
    </div>
  );
};

Spinner.propTypes = {
  message: PropTypes.string
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.jsx